import { createSelector } from 'reselect';
import { FormResolver } from 'src/modules/form/types/FormResolver';
import { getHvacCarbonIntensityEnv } from 'src/modules/hvac/selectors/getHvacCarbonIntensityEnv';
import { HvacFormData } from 'src/modules/hvac/types/HvacFormData';
import { resolveHvacFormData } from 'src/modules/hvac/utils/resolveHvacFormData';

export const getHvacFormResolver = createSelector([
  getHvacCarbonIntensityEnv,
], (environment): FormResolver<HvacFormData> => (prevValues, nextValues) => resolveHvacFormData(
  environment,
  prevValues,
  nextValues,
));
